import { LocalClientToken } from "../../../../utils/local-client-token";

export function useExitModalHook() {
  function logout() {
    LocalClientToken.clearStoredToken();
    window.location.href = "/";
  }

  return {
    logout,
  };
}
